export interface IUploadBillFileRequest {
  jointBillServiceId: number;
  fileContentBase64: string;
}

export enum BillFileParsingState {
  AutomaticParsing = "automaticParsing",
  ManualParsing = "manualParsing",
}

export enum BillFileResponseType {
  OnRequest = "onRequest",
  Callback = "callback",
}

export interface IUploadBillFileResponse {
  billFileParsingState: BillFileParsingState;
  billFileResponseTypeId: BillFileResponseType;
  billFileId: number;
  billFileKey: string;
  customerCode: string;
  total: number;
  iban: string;
  serviceProviderId: number;
  serviceProviderName: number;
}

export interface IUploadBillFileConfirmRequest {
  jointBillServiceId: number;
  billFileId: number;
  customerCode: string;
  total: number;
  iban?: string;
}

export interface IUploadBillFileConfirmResponse {
  success: boolean;
  error?: string;
}

export interface IBillFileRequest {
  billId: number;
  jointBillServiceId: number;
}

export interface IBillFileResponse {
  fileName: string;
  data: string;
}
